import { render, staticRenderFns } from "./CfgComprador.vue?vue&type=template&id=d9a942a6&scoped=true"
import script from "./CfgComprador.vue?vue&type=script&lang=js"
export * from "./CfgComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a942a6",
  null
  
)

export default component.exports